import React from 'react';
import Styles from './lesson-grid-item-current-styles.scss';
import classNames from 'classnames';
import { CirclePlayButton } from '@/presentation/components';
const LessonGridItemCurrent = ({ locked = false, lesson, onClick: onClickParam, id }) => {
    const handleClick = () => {
        if (onClickParam && !locked)
            onClickParam();
    };
    return (React.createElement("div", { className: Styles.lessonsGridItemWrap },
        React.createElement("div", { className: classNames([Styles.content, locked ? Styles.locked : Styles.free]) },
            React.createElement("div", { className: Styles.number },
                React.createElement("span", { className: Styles.numberContent }, id)),
            React.createElement("div", { className: Styles.name, onClick: handleClick },
                React.createElement("h3", null, lesson.name)),
            React.createElement("div", { className: Styles.score },
                React.createElement("div", { className: Styles.scoreContent }, "Current Lesson")),
            React.createElement("div", { className: Styles.icon },
                React.createElement(CirclePlayButton, { background: locked ? 'gray' : 'blue', onClick: handleClick })))));
};
export default LessonGridItemCurrent;
